import { Dropdown, Panel, PanelType, Stack } from 'office-ui-fabric-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import React, { Component, Fragment } from 'react';
import { DataLotCommercial } from '../../data/DataLotCommercial.jsx';
import { Immocom } from '../../specifique/immocom';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    onAffiche
    onFerme : méthode
****************************************************************/

var objetState = {
    idLotCommercial: 0,
    idOperation: 0,
    options: [],

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

export class FicheLotCommercialSuppression extends Component {

    _creationContent = () => {
        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Panel
                isOpen={this.props.onAffiche}
                type={PanelType.medium}
                onDismiss={this._onAnnulation}
                onOpen={this._onOpen}
                headerText="Suppression des lots commerciaux vides"
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <Stack horizontal verticalAlign="end" gap={5}>
                    <Stack.Item grow>
                        <Dropdown
                            label="Sélectionnez votre numéro de lot commercial :"
                            onChange={this._onChange}
                            options={this.state.options}
                            placeholder="Selectionnez"
                            selectedKey={this.state.idLotCommercial}
                            required
                        />
                    </Stack.Item>
                    <DefaultButton
                        disabled={!this.state.idLotCommercial}
                        onClick={this._onSuppression}
                        text="Supprimer"
                    />
                </Stack>
            </Panel>

        </Fragment>;
    }

    _chargementDonnees = () => {
        DataLotCommercial._chargementLotCommercialVide().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

            if (retourVerif === null) {
                const { idOperation, list } = responseFetch.reponseAPIobjet;
                if (!list) {
                    this.setState({ hideMessageBarWarning: false, warningMessage: 'Aucune donnée éligible à la suppression' })
                } else {
                    let options = [{ key: 0, text: 'Sélectionnez' }];
                    list.map(item => {
                        options.push({
                            key: item.idLotCommercial,
                            text: item.numero
                        })
                    });
                    this.setState({ ...objetState, options: options, idOperation });
                }
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onAnnulation = () => {
        this.setState({ ...objetState }, this.props.onFerme);
    }

    _onChange = (event, option) => {
        this.setState({
            idLotCommercial: option.key
        });
    };

    _onSuppression = () => {
        const { idOperation, idLotCommercial } = this.state;
        if (idOperation === 0 || idLotCommercial === 0) {
            this.setState({ hideMessageBarError: false, errorMessage: 'Veuillez sélectionner un numero de lot commercial vide' })
        } else {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Suppression en cours..."
            });
            DataLotCommercial._onSuppressionLotsCommerciauxVides(idOperation, idLotCommercial).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, objetState, this._chargementDonnees);
                } else {
                    Immocom.onTraitementErreurAvecState(this, objetState, retourVerif, responseFetch);
                }
            });
        }
    };

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton onClick={this._onAnnulation}>Fermer</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        this._chargementDonnees();
    }

    render = () => {
        return this._creationContent();
    }
}
